// extracted by mini-css-extract-plugin
module.exports = {"header":"ContentPage_header__2NIbg","container":"ContentPage_container__2zsfe","rightSection":"ContentPage_rightSection__1JMak"};